module.exports = __webpack_public_path__ + "img/btn-border-green.07de02a.svg";